import type { Decimal } from '@snap-types/types/decimal';

import { LeadTimeCalculatorInput } from './input';
import { runStrategy } from './run-strategy';
import { LeadTimeCalculatorOutput, type LeadTimeStrategy } from './types';

export function calculateLeadTime(
  quantity: Decimal,
  strategy: LeadTimeStrategy | null | undefined,
  input: LeadTimeCalculatorInput,
): LeadTimeCalculatorOutput {
  if (!strategy) {
    return {
      leadTimeStrategy: null,
      weeks: null,
    };
  }

  const result = runStrategy(quantity, strategy, input);

  return {
    leadTimeStrategy: result.name,
    weeks: result.weeks,
  };
}
